import classNames from 'classnames';
import { FC } from 'react';

import { IcArrowBack16Icon } from '@gem/icons';

import styles from './AllDownloadsIcon.styles.m.css';

interface IAllDownloadsIconProps {
  progress?: number;
}

export const AllDownloadsIcon: FC<IAllDownloadsIconProps> = (props) => {
  const { progress = 0 } = props;

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <IcArrowBack16Icon className={styles.icon} />
      </div>
      <div className={classNames(styles.bar, { [styles.downloadEnded]: progress === 100 })}>
        <div
          className={styles.progressBar}
          style={{ width: progress < 100 ? `${progress}%` : 0 }}
        />
      </div>
    </div>
  );
};
